import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Group,
  Input,
  Select,
  SelectProps,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconEdit,
  IconFunction,
  IconPlus,
  IconSearch,
  IconTrash,
  IconUser,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _timerDelaySearch } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  createMenuGroup,
  deleteMenuGroup,
  editMenuGroup,
  getListMenuGroup,
} from "../../../api/ApiAdmin";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { CreateMenuGroup, UserMenuGroup } from "../../../model/MenuGroup";
import AddRouterToMenuGroup from "./AddRouterToMenuGroup";
import MenuGroupEmployAdd from "./MenuGroupEmployAdd";
import { useLocation } from "react-router-dom";

const MenuGroupListView = () => {
  //#region  table
  const headerRef = React.useRef<HTMLDivElement>(null);
  //data and fetching state
  const [data, setData] = useState<UserMenuGroup[]>([]);
  const [dataTemp, setDataTemp] = useState<UserMenuGroup[]>([]);

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 50,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [keySearch, setKeySearch] = useDebouncedState(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );
  const [active, setActive] = useState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.active : ""
  );
  const [dataSubmit, setDataSubmit] = useState<CreateMenuGroup>({
    id: "",
    name: "",
    active: true,
    createDate: null,
    lastUpdateDate: null,
    createBy: null,
    lastUpdateBy: null,
  });
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [selectIds, setSelectIds] = useState<string[]>([]);

  const [deleteViewStatus, setDeleteViewStatus] = useState(0);
  //count
  const [timeLeft, setTimeLeft] = useState(_timerDelaySearch);
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelaySearch);
      setIsCounting(true);
    }
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus, sorting, pagination.pageIndex, pagination.pageSize]);

  const fetchData = async () => {
    if (!isCounting) {
      startCountdown();
      setIsLoading(true);
      setIsRefetching(true);
      setOpenedMenu(false);
      try {
        let urlGet =
          "?Skip=" +
          pagination.pageIndex * pagination.pageSize +
          "&Take=" +
          pagination.pageSize;
        if (keySearch && keySearch.length > 0)
          urlGet = urlGet + "&KeySearch=" + keySearch;
        if (active && active.length > 0) {
          urlGet = urlGet + "&Active=" + active;
        }
        const response = await getListMenuGroup(urlGet);
        if (response && response.success) {
          setData(response.data ?? []);
          setRowCount(response.totalCount);
          setSelectIds([]);
          table.resetRowSelection();
        } else {
          setData([]);
          setRowCount(0);
          setSelectIds([]);
          table.resetRowSelection();
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        sessionStorage.setItem(
          String(location.pathname),
          JSON.stringify({ keySearch: keySearch, active: active })
        );
      }
    }
  };

  const deletesData = async (ids: string[]) => {
    const res = await deleteMenuGroup(ids);

    if (res && res?.success) {
      NotificationExtension.Success("Xóa nhóm menu thành công !");
      modals.closeAll();
      fetchData();
    }
  };

  const modalsDeleteData = (ids: string[]) => {
    modals.openConfirmModal({
      title: "Xóa nhóm menu",

      size: "30vw",
      fullScreen: false,
      children: (
        <Flex direction={"column"} gap={"md"} mt={5}>
          <Text fw={500} size="lg">
            Bạn có chắc muốn xóa các nhóm menu này ?
          </Text>
          <Flex justify={"flex-end"} gap={"md"}>
            <Button
              variant="outline"
              color="gray"
              leftSection={<IconX size={14} />}
              onClick={() => modals.closeAll()}
            >
              Hủy
            </Button>
            <Button
              variant="outline"
              color="red"
              leftSection={<IconCheck size={14} />}
              onClick={() => deletesData(ids)}
            >
              Xác nhận
            </Button>
          </Flex>
        </Flex>
      ),
      labels: { confirm: "Confirm", cancel: "Hủy bỏ" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const groupAddRoleModal = (idAuthozire: string) => {
    modals.closeAll();

    modals.openConfirmModal({
      title: "Danh sách nhóm",

      size: "auto",
      children: <AddRouterToMenuGroup idGroup={idAuthozire} />,
      labels: { confirm: "Confirm", cancel: "Hủy bỏ" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const groupAddEmpModal = (idAuthozire: string) => {
    modals.closeAll();

    modals.openConfirmModal({
      title: "Danh sách nhân viên",
      size: "auto",
      children: <MenuGroupEmployAdd idGroup={idAuthozire} />,
      labels: { confirm: "Confirm", cancel: "Hủy bỏ" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function getColorStatus(text: boolean) {
    switch (text) {
      case true:
        return "teal";
      default:
        return "red";
    }
  }

  const optionColorActive: Record<"Đang hoạt động" | "Dừng hoạt động", string> =
    {
      "Đang hoạt động": "teal",
      "Dừng hoạt động": "red",
    };

  const renderSelectOptionActive: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorActive[option.label as "Đang hoạt động" | "Dừng hoạt động"]
        }
        radius="lg"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const columns = React.useMemo<MRT_ColumnDef<UserMenuGroup>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Tên nhóm",
        Edit: ({ row, column, table }) => {
          return (
            <TextInput
              placeholder="Tên nhóm"
              value={dataSubmit.name}
              onChange={(e) => {
                setDataSubmit((prev) => ({
                  ...prev,
                  name: e.currentTarget.value,
                }));
              }}
            />
          );
        },
      },
      // {
      //   accessorKey: "listrouter",
      //   header: "Tên đầy đủ",
      // },
      {
        accessorKey: "active",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorStatus(row.original.active ?? false)}>
              {row.original.active ? "Đang hoạt động" : "Dừng hoạt động"}
            </Badge>
          </>
        ),
        Edit: ({ row, column, table }) => {
          return (
            <Select
              placeholder="Trạng thái"
              value={dataSubmit.active?.toString()}
              data={[
                { label: "Đang hoạt động", value: "true" },
                { label: "Dừng hoạt động", value: "false" },
              ]}
              onChange={(e) => {
                setDataSubmit((prev) => ({
                  ...prev,
                  active: e === "true" ? true : false,
                }));
              }}
            />
          );
        },
      },
      {
        accessorKey: "createBy",
        header: "Người tạo",
        enableEditing: false,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo (UTC)",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableEditing: false,
      },

      {
        accessorKey: "action",
        header: "Phân quyền và thao tác",
        size: 175,
        enableEditing: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Tooltip label="Nhóm">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={() => {
                  groupAddRoleModal(row.original.id.toString());
                }}
              >
                <IconFunction size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Nhân viên">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={() => {
                  groupAddEmpModal(row.original.id.toString());
                }}
              >
                <IconUser size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={() => {
                  setIsEdit(true);
                  table.setEditingRow(row);
                  setDataSubmit((prev) => ({
                    ...prev,
                    id: row.original.id,
                    name: row.original.name,
                    active: row.original.active,
                    createBy: row.original.createBy,
                    createDate: row.original.createDate,
                  }));
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={() => {
                  modalsDeleteData([row.original.id.toString()]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataSubmit]
  );
  const [openedMenu, setOpenedMenu] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: isEdit ? "row" : "custom", // ('modal', 'row', 'cell', and 'custom' are also available)
    enableEditing: true,
    enableTopToolbar: false,
    renderRowActions: () => <></>,
    //add custom action buttons to top-left of top toolbar

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    onCreatingRowCancel: () => {
      setDataSubmit({
        id: "",
        name: "",
        active: true,
        createDate: null,
        lastUpdateDate: null,
        createBy: null,
        lastUpdateBy: null,
      });
    },
    onCreatingRowSave: async ({ exitCreatingMode, values, table }) => {
      try {
        const response = await createMenuGroup({
          ...dataSubmit,
          createDate: new Date(
            new Date().getTime() + 7 * 60 * 60 * 1000
          ).toISOString(),
          lastUpdateDate: new Date(
            new Date().getTime() + 7 * 60 * 60 * 1000
          ).toISOString(),
          createBy: JSON.parse(localStorage.getItem("userData") || "{}")?.empId,
          lastUpdateBy: JSON.parse(localStorage.getItem("userData") || "{}")
            ?.empId,
        });
        if (response && response.success) {
          NotificationExtension.Success("Tạo nhóm menu thành công!");
          exitCreatingMode();
          setDataSubmit({
            id: "",
            name: "",
            active: true,
            createDate: null,
            lastUpdateDate: null,
            createBy: null,
            lastUpdateBy: null,
          });
          fetchData();
        }
      } catch (error) {
        NotificationExtension.Fails("Có lỗi xảy ra khi tạo nhóm!");
      }
    },
    onEditingRowCancel: () => {
      setIsEdit(false);
    },
    onEditingRowSave: async ({ exitEditingMode, values, table }) => {
      try {
        const response = await editMenuGroup({
          ...dataSubmit,
          lastUpdateDate: new Date(
            new Date().getTime() + 7 * 60 * 60 * 1000
          ).toISOString(),
          lastUpdateBy: JSON.parse(localStorage.getItem("userData") || "{}")
            ?.empId,
        });
        if (response && response.success) {
          NotificationExtension.Success("Sửa nhóm menu thành công!");
          exitEditingMode();
          setDataSubmit({
            id: "",
            name: "",
            active: true,
            createDate: null,
            lastUpdateDate: null,
            createBy: null,
            lastUpdateBy: null,
          });
          setIsEdit(false);
          fetchData();
        }
      } catch (error) {
        NotificationExtension.Fails("Có lỗi xảy ra khi sửa nhóm!");
      }
    },
    getRowId: (row) => row?.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        // right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: {
        pageIndex: 0,
        pageSize: 50,
      },
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "bold", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
        //  backgroundColor: row.original.userName.length>0 ? "white" : "gray",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "150"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  //#endregion
  return (
    <>
      <div className="mt-5">
        <div ref={headerRef} style={{ width: "100%" }}>
          <Flex
            justify={"space-between"}
            wrap={"wrap"}
            align={"center"}
            w={"100%"}
          >
            <_breadcrumb></_breadcrumb>
            <Flex gap="md" justify={"end"} align={"center"} wrap="wrap">
              <Button
                leftSection={<IconPlus size={14} />}
                color="blue"
                variant="outline"
                onClick={() => {
                  table.setCreatingRow(true);
                }}
              >
                Thêm mới
              </Button>
              <Button
                leftSection={<IconTrash size={14} />}
                color="red"
                variant="outline"
                onClick={() => {
                  modalsDeleteData(selectIds);
                }}
                disabled={selectIds.length < 1}
              >
                Xóa nhóm (đã chọn)
              </Button>
            </Flex>
          </Flex>
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
            mt={5}
          >
            <Input
              placeholder="Nhập từ khóa ..."
              defaultValue={keySearch}
              onChange={(e) => {
                setKeySearch(e.target.value ?? "");
              }}
            />
            <Select
              placeholder="Trạng thái hoạt động"
              data={[
                { label: "Đang hoạt động", value: "true" },
                { label: "Dừng hoạt động", value: "false" },
              ]}
              value={active}
              renderOption={renderSelectOptionActive}
              onChange={(e) => setActive(e ? e : "")}
            />

            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              disabled={isCounting}
              onClick={async () => {
                await fetchData();
              }}
            >
              {timeLeft > 0 && timeLeft} Tìm kiếm
            </Button>
          </Flex>
        </div>
        <Box mt={10}>
          <MantineReactTable table={table} />
        </Box>
      </div>
    </>
  );
};

export default MenuGroupListView;
